const API = {
  BASE_DOMAIN: process.env.ROOT_API,
  BASE_URL: process.env.ROOT_API + "/api",
  RESERVED_DATES: "/reserved-dates",
  BOOKINGS: "/bookings",
  DEPOSIT: "/deposit",
  REGISTER: "/register",
  RESERVATIONS: "/reservations",
  GUEST_RESERVATIONS: "/guests/reservations",
  GUEST_BOOKINGS: "/guests/bookings",
  EMPLOYEES: "/employees",
  EMPLOYEE_TYPES: "/employees/types",
  VENDOR_CURRENT: "/vendor/current",
  VENDOR: "/vendor",
  TABS: "/tabs",
  TAB: "/tab",
  INVOICES: "/invoices",
  ITEMS: "/items",
  TABITEMS: "/tabitems",
  MENUS: "/menus",
  PACKAGES: "/packages",
  PACKAGETAGS: "/packagetags",
  MODIFIERS: "/modifiers",
  UNIT: "/unit",
  UNIT_AVAILABILITY: "/unit/availability",
  UNIT_LIST: "/unittype/list",
  UNIT_TYPE: "/unittype",
  UNIT_TYPE_LIST: "/unittype/list",
  GUESTS: "/guests",
  IMAGE: "/image/",
  NOTES: "/notes",
  GUESTS_ALL: "/guests/all",
  ACCOUNT: "/account",
  ACCOUNT_CURRENT: "/account/current",
  ANALYTICS: "/analytics",
  SIMPLE_STATS: "/simple",
  OCCUPANCY_REPORT: "/occupancy",
  SUMMARY_REPORT: "/summary",
  TRANSACTION_REPORT: "/transaction",
  TAGS: "/tags",
  MENU_TAGS: "/menutags",
  ITEM_TAGS: "/itemtags",
  MODIFIER_TAGS: "/modifiertags",
  GUEST_REPORT: "/guest",
  GUEST_FLUX_REPORT: "/flux",
  VIRTUAL_KEY_CONNECT: "/vendor/virtualkeyconnect",
  VIRTUAL_KEY_UNIT_LINK: "/unit/virtualkeyconnect",
  STRIPE_CHARGE: "/stripecharge",
  STRIPE_TOKEN: "/stripetoken",
  STRIPE_CONNECT: "/stripeconnect",
  STRIPE_TERMINAL: "/stripe/terminal",
  BACKEND_PAYMENT: "/stripe/payment",
  CONNECT: "/connect",
  INTENT: "/intent",
  CAPTURE: "/capture",
  CANCEL: "/cancel",
  // REGISTER: "/register",
  LOCATION: "/location",
  CUSTOMER: "/customer",
  CHANNEX_SIGN_IN: "/channex/sign-in",
  CHANNEX_REFRESH_TOKEN: "/channex/refresh",
  CHANNEX_STATUS: "/channex/status",
  CHANNEX_CONNECT: "/channex/property",
  CHANNEX_SUBSCRIBE: "/channex/subscribe",
  CHANNEX_ROOM_LIST: "/channex/room/list",
  CHANNEX_CONNECT_ROOM: "/channex/room/connect",
  CHANNEX_DISCONNECT_ROOM: "/channex/room/disconnect",
  CHANNEX_SYNC_ALL_UNITS: "/channex/room/sync-units",
  CHANNEX_SYNC_ALL_RATES: "/channex/room/sync-rates",
  CHANNEX_IMPORT_BOOKINGS: "/channex/bookings/import",
  // Subscription
  SUBSCRIPTION: "/subscription",
  TOKEN_TYPE: "Bearer",
  TOKEN() {
    return (
      localStorage.getItem("auth_token") || localStorage.getItem("access_token")
    );
  },
  RequestHeaders() {
    return {
      headers: {
        Authorization: `${this.TOKEN_TYPE} ${this.TOKEN()}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
  },

  FormRequestHeaders() {
    return {
      headers: {
        Authorization: `${this.TOKEN_TYPE} ${this.TOKEN()}`,
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
      },
    };
  },
};

export default API;
